import { connect } from 'react-redux'
import * as action from '../../state/plan/action'
import * as selector from '../../state/plan/selector'
import * as processSelector from '../../../process/state/instance-detail/selector'
import * as processAction from '../../../process/state/instance-detail/action'
import {isIPRProviderStore} from "../../../globals/state/selector";
import {selectCustomer} from "../../../customer/state/detail/selector";
import IPRInstructions from '../plan/IPRInstructions'

const mapStateToProps = (state, props) => {
    const customer = selectCustomer(state)
    return {
        treatmentPlan: selector.selectTreatmentPlan(state),
        context: processSelector.selectProcessContext(state),
        isWidget: true,
        isIPRProviderStore: isIPRProviderStore(state, customer.store),
    }
}

const mapDispatchToProps = {
    saveTreatmentPlan: action.saveTreatmentPlan,
    changeTreatmentPlan: action.changeTreatmentPlan,
    changeIPRInstruction: action.changeIPRInstruction,
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(mapStateToProps, mapDispatchToProps)(IPRInstructions)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/IPRInstructionsWidgetContainer.js